import { render, staticRenderFns } from "./SendWorkflowAction.vue?vue&type=template&id=68e3e0bb&scoped=true"
import script from "./SendWorkflowAction.vue?vue&type=script&lang=js"
export * from "./SendWorkflowAction.vue?vue&type=script&lang=js"
import style0 from "./SendWorkflowAction.vue?vue&type=style&index=0&id=68e3e0bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e3e0bb",
  null
  
)

export default component.exports